export { QuickLinkType, QuickLinkAccessTo } from './quicklink-type.enum';
